/* eslint-disable max-len */
import { _initialState } from './_initialState';
import {
  cabinetCollectionSelectionOverlayEvent,
  addItemToWallEvent,
  collectionViewDetailsEvent,
  addWallOverlayEvent,
  collectionRefinementsFiltersEvent,
  cabinetCollectionSelectionInteractionEvent,
  aboutThisCollectionEvent,
  addWallInteractionEvent,
  editWallOverlayEvent,
  editWallInteractionEvent,
  chooseCabinetOverlay,
  rulerViewInteractionEvent,
  zoomInteractionEvent
} from './actions';

export const cabinetVisualizerDigitalDataStore = (set, get) => ({
  ..._initialState,
  trackCabinetCollectionSelectionOverlayEvent: (payload) => cabinetCollectionSelectionOverlayEvent(set, get, payload),
  trackAddItemToWallEvent: (payload) => addItemToWallEvent(set, get, payload),
  trackCollectionViewDetailsEvent: (payload) => collectionViewDetailsEvent(set, get, payload),
  trackAddWallOverlayEvent: (payload) => addWallOverlayEvent(set, get, payload),
  trackCollectionRefinementsFiltersEvent: (payload) => collectionRefinementsFiltersEvent(set, get, payload),
  trackCabinetCollectionSelectionInteractionEvent: (payload) => cabinetCollectionSelectionInteractionEvent(set, get, payload),
  trackAboutThisCollectionEvent: (payload) => aboutThisCollectionEvent(set, get, payload),
  trackAddWallInteractionEvent: (payload) => addWallInteractionEvent(set, get, payload),
  trackEditWallOverlayEvent: (payload) => editWallOverlayEvent(set, get, payload),
  trackEditWallInteractionEvent: (payload) => editWallInteractionEvent(set, get, payload),
  trackChooseCabinetOverlayEvent: (payload) => chooseCabinetOverlay(set, get, payload),
  trackRulerViewInteractionEvent: (payload) => rulerViewInteractionEvent(set, get, payload),
  trackZoomInteractionEvent: (payload) => zoomInteractionEvent(set, get, payload),
});